import ErrorHandler from "@/lib/errorHandler";
import { get_policy_by_code } from "@/Redux/Actions/Settings";
import { useAppDispatch } from "@/Redux/app/hooks";
import usePageLoader from "@/Redux/hooks/usePageLoader";
import useSnackBar from "@/Redux/hooks/useSnackBar";
import { Box, Typography } from "@mui/material";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

type PolicyData = {
    _id: string;
    name: string;
    description: string;
};

export default function PolicyPage() {
    const router = useRouter();
    const dispatch = useAppDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();
    const { id } = router.query;

    const [policy, setPolicy] = useState<PolicyData | null>(null);

    const _getPolicyByCode = async (policyCode: string) => {
        setFullPageLoader(true);
        const response = await dispatch(get_policy_by_code(policyCode));
        if (ErrorHandler(response, setSnackBar)) {
            const payload = response.payload as { data: PolicyData };
            setPolicy(payload.data);
        }
        setFullPageLoader(false);
    };

    useEffect(() => {
        if (!router.isReady) return;
        if (typeof id === "string") _getPolicyByCode(id);
    }, [router.isReady, id]);

    return (
        <Box sx={{ position: "relative", minHeight: "100vh", px: 2, pb: { xs: 6, md: 10 }, pt: { xs: 6, md: 8 }, display: "flex", justifyContent: "center", background: "#ffffff", overflowX: "hidden" }}  >
            <div className="animated-bg">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <Box sx={{ width: "100%", maxWidth: "900px", position: "relative", zIndex: 2, }} >
                <Typography fontSize={{ xs: 28, md: 40 }} fontWeight={700} textAlign="center" mb={6} sx={{ color: "#FF8300" }} >
                    {policy?.name}
                </Typography>
                {policy && (
                    <Box className="policy-html" sx={{ lineHeight: 1.9 }} dangerouslySetInnerHTML={{ __html: policy.description }} />
                )}
            </Box>
        </Box>
    );
}
